<template>
  <div type="button" :disabled="disabled" :class="classObject" @click="clickEvent">
    <slot />
  </div>
</template>

<script>

export default {
  name: 'GButton',

  props: {
    type: {
      default: ''
    },
    disabled: {
      default: false
    },
    round: {
      default: true
    },
    hollow: {// 镂空
      default: false
    },
    size: {
      default: 'middle'
    }
  },

  computed: {
    classObject() {
      const { type, disabled, round, hollow, size } = this
      return {
        'g-button': true,
        'disabled': disabled,
        [`${type}`]: type,
        'round': round,
        'hollow': hollow,
        [`${size}`]: size,
        'click': true
      }
    },

    shouldShowLabel() {
      return this.label !== '' || this.textEnabled !== '' || this.textDisabled !== ''
    }
  },
  methods: {
    clickEvent() {
      if (this.classObject['g-button-disabled']) return
      this.$emit('click')
    }
  }
}

</script>

<style scoped lang="scss">
  @import '@/styles/variables.scss';
.g-button {
  display: inline-block;
  font-size: 14px;
  color: #fff;
  border-radius: 6px;
  min-width: 100px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  cursor: pointer;
  border: 1px solid transparent;
  padding: 0 10px;
  &.small {
    min-width: 80px;
    height: 30px;
    line-height: 30px;
    font-size: 12px;
  }
  &.primary {
    background: linear-gradient(to bottom, #74d27c, #0cc057);
    color: #fff;
  }
  &.gray {
    background-color: #333;
  }
  &.round {
    border-radius: 50px;
  }
  &.error {
    color: #C03639;
    background-color: #333;
  }
  &.hollow {
    background-color: transparent;
    background: none;
    border-color: #999;
  }
  &.disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
  &.text {
    background-color: transparent;
  }
  &.greenW {
    background-color: #333;
  }
  // &.energy {
  //   background-color: $energy;
  //   color: #fff;
  // }
  // &.kisae {
  //   background-color: $kisae;
  //   color: #fff;
  // }
}

.energy {
  .g-button {
    &.primary {
      // background: $energy;
    }
  }
}

.kisae {
  .g-button {
    &.primary {
      // background: $kisae;
    }
  }
}

// .theme-light {
  .g-button {
    color: #333;
    &.primary {
      color: #fff;
    }
    &.gray {
      background-color: #f8f8f8;
      color: #333;
    }
    &.error {
      // color: $red;
      background-color: #f8f8f8;
    }
    &.greenW {
      background: #E0F7EB;
      color: #30B08F;
    }
  }
// }
</style>
